module.exports = __webpack_public_path__ + "img/34.2dd0bc49.webp";